import { nodePdfServiceBaseUrl } from "services/http";

export const nodeService = {
  createPdf: `${nodePdfServiceBaseUrl}/htmlToPdf`
};
